import {createAction} from 'redux-actions'

export const select = createAction('SELECTION/SELECT')
export const reverse = createAction('SELECTION/REVERSE')
export const selectAll = createAction('SELECTION/SELECT_ALL')
export const deselect = createAction('SELECTION/DESELECT')
export const deselectAll = createAction('SELECTION/DESELECT_ALL')